// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox-checkbox-89f8","check":"Checkbox-check-89f8","text":"Checkbox-text-89f8","checked":"Checkbox-checked-89f8","error":"Checkbox-error-89f8"};